module.exports = __webpack_public_path__ + "img/m1-front.844e3392.jpg";